import { useEffect, useState } from 'react'

/**
 * True on desktop-width screens. Drives the Exchange Desk device model:
 * mobile → Buy AU only; desktop → Buy or Administration.
 */
export function useIsDesktop(minWidth = 1024) {
  const query = `(min-width: ${minWidth}px)`
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : true
  )

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
    const mq = window.matchMedia(query)
    const onChange = () => setIsDesktop(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])

  return isDesktop
}
